import AppShell from '@/components/AppShell'
import { useState } from 'react'
import { upsertLoad } from '@/lib/mockApi'
import type { LoadTicket } from '@/lib/types'
import { useNotifications } from '@/lib/notifications'
import { logAudit } from '@/lib/audit'
import { get } from '@/lib/storage'

const empty: LoadTicket = {
  id: '',
  status: 'Entered',
  destination: 'Holly Hill Export Yard'
}

export default function PaperEntry(){
  const [form, setForm] = useState<LoadTicket>({...empty})
  const { push } = useNotifications()

  function set<K extends keyof LoadTicket>(k: K, v: LoadTicket[K]){
    setForm(f => ({ ...f, [k]: v }))
  }

  function newId(){
    const base = form.scaleNumber || form.securityTag || Math.floor(Math.random()*1e6).toString()
    return `PE-${base}`
  }

  async function save(){
    if (!form.scaleNumber && !form.securityTag) {
      push({ title:'Need a Scale # or Security Tag', level:'warning' })
      return
    }
    const id = form.id || newId()
    const row: LoadTicket = { ...form, id }
    await upsertLoad(row)
    logAudit({ action:'paper-entry-save', details: row }, get('role','Admin'))
    push({ title:'Load saved', body:id })
    setForm({...empty})
  }

  return (
    <AppShell title="Paper Entry">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">

        <div className="card">
          <div className="card-header">Ticket Info</div>
          <div className="card-body grid grid-cols-1 md:grid-cols-3 gap-3">
            <input className="input" placeholder="Security Tag" value={form.securityTag||''} onChange={e=>set('securityTag', e.target.value)} />
            <input className="input" placeholder="Scale #" value={form.scaleNumber||''} onChange={e=>set('scaleNumber', e.target.value)} />
            <select className="select" value={form.status||'Entered'} onChange={e=>set('status', e.target.value as any)}>
              <option>Entered</option><option>Delivered</option><option>Settled</option><option>Reconciled</option>
            </select>

            <input className="input" placeholder="Logging Company" value={form.loggingCompany||''} onChange={e=>set('loggingCompany', e.target.value)} />
            <input className="input" placeholder="Trucking Company" value={form.truckingCompany||''} onChange={e=>set('truckingCompany', e.target.value)} />
            <input className="input" placeholder="Driver" value={form.driver||''} onChange={e=>set('driver', e.target.value)} />

            <input className="input" placeholder="Destination" value={form.destination||''} onChange={e=>set('destination', e.target.value)} />
            <input className="input" type="number" step="0.001" placeholder="Net Tons" value={form.netTons ?? ''} onChange={e=>set('netTons', Number(e.target.value))} />
            <input className="input" type="date" placeholder="Delivered At" value={form.deliveredAt||''} onChange={e=>set('deliveredAt', e.target.value)} />

            <input className="input" type="number" placeholder="Gross Weight (lb)" value={form.grossWeight ?? ''} onChange={e=>set('grossWeight', Number(e.target.value))} />
            <input className="input" type="number" placeholder="Tare Weight (lb)" value={form.tareWeight ?? ''} onChange={e=>set('tareWeight', Number(e.target.value))} />
            <input className="input" placeholder="Product ID" value={form.productId||''} onChange={e=>set('productId', e.target.value)} />
          </div>
        </div>

        <div className="card">
          <div className="card-header">Container / Export</div>
          <div className="card-body grid grid-cols-1 md:grid-cols-3 gap-3">
            <input className="input" placeholder="Container #" value={form.containerNumber||''} onChange={e=>set('containerNumber', e.target.value)} />
            <input className="input" placeholder="Seal #" value={form.sealNumber||''} onChange={e=>set('sealNumber', e.target.value)} />
            <input className="input" placeholder="Container Type" value={form.containerType||''} onChange={e=>set('containerType', e.target.value)} />

            <input className="input" placeholder="Shipping Line" value={form.line||''} onChange={e=>set('line', e.target.value)} />
            <input className="input" placeholder="Voyage" value={form.voyage||''} onChange={e=>set('voyage', e.target.value)} />
            <input className="input" placeholder="Port" value={form.port||''} onChange={e=>set('port', e.target.value)} />

            <input className="input" placeholder="Fumigation Status" value={form.fumigationStatus||''} onChange={e=>set('fumigationStatus', e.target.value)} />
          </div>
        </div>

        <div className="lg:col-span-2">
          <div className="card">
            <div className="card-body flex gap-2">
              <button className="btn" onClick={save}>Save Load</button>
              <button className="btn-secondary" onClick={()=>setForm({...empty})}>Reset</button>
            </div>
          </div>
        </div>

      </div>
    </AppShell>
  )
}
